<template>
  <div class="around-my-slider">
    <div id="my-simple-slider" :se-min="minThreshold" :se-step="step" :se-value="value" :se-max="maxThreshold" class="slider">
      <div class="slider-touch-right">
        <span></span>
      </div>
      <div class="slider-line">
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>

import ZbRangeSlider2 from './ZbRangeSlider2' //attention ! certaines valeurs du JS sont des paramètres qui dépendent des margins et paddings mis dans ce component (voir les 'TODO edited par bleu122')

export default {

  name: 'SimpleRangeSliderField2',

  props: {
    minThreshold: {
      type: Number,
      default: -100
    },
    maxThreshold: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      required: true
    },
  },
  data: function () {
    return {
      instance: undefined
    }
  },
  mounted: function () {
    this.instance = new ZbRangeSlider2('my-simple-slider')
    this.instance.onChange = (value) => this.updateValue(value)
  },
  destroyed: function () {

  },
  methods: {
    updateValue: function (value) {
      this.$emit('update:value', value)
    },

  }
}

</script>

<style scoped>

/** ajouté par bleu122 */
.around-my-slider {
  margin-left: -18px;
  margin-right: -18px;
}
.slider {
  display: block;
  position: relative;
  height: 36px;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.slider .slider-touch-right {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: block;
  position: absolute;
  height: 34px;
  width: 34px;
  padding: 6px;
  z-index: 2;
  cursor: pointer;
}
.slider .slider-touch-right span {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--main-yellow-medium);
  border: 1px solid var(--main-yellow-medium);
  border-radius: 50%;
}
.slider .slider-line {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: calc(100% - 36px);
  left: 18px;
  top: 14px;
  height: 6px;
  border-radius: 6px;
  background: var(--main-grey-light);
  z-index: 0;
  overflow: hidden;
}
.slider .slider-line span {
  display: block;
  height: 100%;
  width: 0%;
  background: var(--main-yellow-medium);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/SimpleRangeSliderField.vue